import { ViewType } from "@/domain/ViewType";
import { viewTypeBerthScheduleView } from "@/viewType/viewTypes/Optium/cptDom/views/berthScheduleView";
import { viewTypeShipAllocationView } from "@/viewType/viewTypes/Optium/cptDom/views/shipAllocationView";

export const viewTypesCptDom: ViewType<any, any>[] = [
	viewTypeShipAllocationView,
	viewTypeBerthScheduleView,
];
